// extracted by mini-css-extract-plugin
export var activeFilterButton = "_se-c";
export var backButton = "_se-4";
export var backIcon = "_se-5";
export var chevronShortcut = "_se-6";
export var container = "_se-1";
export var editor = "_se-8";
export var editorWrapper = "_se-7";
export var prefix = "_se-2";
export var searchIcon = "_se-3";
export var suffix = "_se-9";
export var suffixContent = "_se-a";
export var suffixText = "_se-b";
export var wrapper = "_se-0";